/**
 * Variables for the course details page's per-semester lists (lecturers and
 * registered students), or null while there is nothing valid to ask for.
 *
 * Both operations take `Int` ids. The route id is a string and the calendar
 * picker hands back the calendar's ID (a string too), so sending them as-is
 * failed with `Int cannot represent non-integer value: "65"`, and a course id
 * read before the course loaded went out as null.
 */
export function courseSemesterVariables(
  courseId: string | number | null | undefined,
  calendarId: string | number | null | undefined,
): { course_id: number; academic_calendar_id: number } | null {
  const course = Number(courseId);
  const calendar = Number(calendarId);
  if (!Number.isInteger(course) || course <= 0) return null;
  if (calendarId === null || calendarId === undefined || calendarId === '' || !Number.isInteger(calendar) || calendar <= 0) {
    return null;
  }
  return { course_id: course, academic_calendar_id: calendar };
}
